import React, { useState, useEffect } from "react";//359, 361, 362, 363, 364
import { Form } from "tabler-react";
import { Crud_Catalogos, Crud_error } from '../../../../herramientas/Crud_Catalogos';
import { TablePageable } from "../../../../Helpers";
import ModalLayout from "../../../../components/ModalLayout.react";
import Select from "react-select";
const  Incidencias =({ accion, elementos, stor, plataforma })=> {//elementos es  plataformasObject
  const [incidencias, setIncidencias]= useState([]);
  const [rutasEstatus, setRutasEstatus]= useState([]);
  const [hiddenModals, setHiddenModals]= useState(false);
  useEffect(() => {
    if(accion !== 'nuevo'){
      getfuntion("get", "", "", "plataformasIncidencias/plataforma/"+elementos.id,"Incidencias");
      getfuntion("get", "", "", "rutasEstatus/plataforma/"+elementos.id,"rutasEstatus");
    }
  },[]);
  const getfuntion = (metodo="get", obj=[], id="", catalogo="", stateVar= "", hiddenModl="") =>{
    return Crud_Catalogos(catalogo, "plataformas", metodo, id, obj,"" , stateVar, hiddenModl, []).then((returnVal) => {
        /**
         * filtro de variables
         */
        switch (metodo) {
          case "get":
            if (stateVar === "Incidencias"){
              setIncidencias(returnVal);
            }
            if (stateVar === "rutasEstatus"){
              let rutasEstatusTemp= [{ value: 0, label: "Seleccione una Opción", data: null }];
              for(let r of returnVal){
                rutasEstatusTemp.push({ value: r.id, label: r.nombre, data: r});
              }
              setRutasEstatus(rutasEstatusTemp);
            }
            break;
          case "post":
            if (stateVar === "Incidencias"){
              getfuntion("get", "", "", "plataformasIncidencias/plataforma/"+elementos.id,"Incidencias");
            }
            break;
          case "delete":
            if (stateVar === "Incidencias"){
              getfuntion("get", "", "", "plataformasIncidencias/plataforma/"+elementos.id,"Incidencias");
            }
            break;
          default:
            break;
        }
      }).catch(err =>{ console.log(err); });
  }
  
  return (
    <div>
      { accion === "modificar" ?
        <div>
          <TablePageable
            titulo={ <h5> Seleccione las Incidencias para su Plataforma </h5> }
            lista= { stor.incidencias_object }
            columnas={
              [
                { columna: "id", label: "Id" },
                { columna: "nombre", label: "Nombre" },
                { columna: "incidenciaTipo.nombre", label: "Tipo" },
                { columna: "idEtiqueta", label: "idEtiqueta" },
                { columna: "etiqueta", label: "Etiqueta",
                  valor: (e)=> {
                    const etiquetaTemp= stor.etiquetas_object.filter(et => et.id === e.idEtiqueta);
                    return etiquetaTemp.length === 1 ? etiquetaTemp[0].nombre: "";
                  },
                  form: (e)=>{
                    const etiquetaTemp= stor.etiquetas_object.filter(et => et.id === e.idEtiqueta);
                    return etiquetaTemp.length === 1 ? etiquetaTemp[0].nombre: "";
                  }
                },
                { columna: "estatus", label: "Estatus",
                  valor: (e)=> incidencias.filter(i => i.incidencia.id === e.id  ).length? true: false,
                  form: (e)=> <Form.Switch type="Checkbox" name="toggle" value="option1"
                  checked={ incidencias.filter(i => i.incidencia.id === e.id  ).length }
                  onChange={ () =>{
                    let plataformasIncidencias={ "plataforma": elementos, "incidencia": e };
                    let incidenciaTemp= incidencias.filter(i => i.incidencia.id === e.id  );
                    incidenciaTemp.length
                    ? getfuntion("delete", "", incidenciaTemp[0].id, "plataformasIncidencias", "Incidencias")
                    :
                      getfuntion("post", plataformasIncidencias, "", "plataformasIncidencias", "Incidencias");
                  }} />
                },
                { columna: "Ruta Estatus", label: "idRuta",
                  valor: (e)=> {
                    let incidenciaTemp= incidencias.filter(i => i.incidencia.id === e.id  );
                    if(incidenciaTemp.length){
                      const rutaEstatusTemp= rutasEstatus.filter(r => r.value === incidenciaTemp[0].idRuta);
                      return rutaEstatusTemp.length === 1 ? rutaEstatusTemp[0].label: "";
                    }
                    return "";
                  },
                  form: (e)=>{
                    let incidenciaTemp= incidencias.filter(i => i.incidencia.id === e.id  );
                    if(incidenciaTemp.length){
                      const rutaEstatusTemp= rutasEstatus.filter(r => r.value === incidenciaTemp[0].idRuta);
                      return <ModalLayout
                                    tamanio={"60%"}
                                    title="Estatus ruta"
                                    name={
                                      <span className="badge btn">
                                        <i className="fa fa-edit" style={{color: "blue"}}></i>
                                        <span className="text-dark">{rutaEstatusTemp.length === 1 ? rutaEstatusTemp[0].label: ""}</span>
                                      </span>
                                    }
                                    hiddenModal={()=> setHiddenModals(!hiddenModals)}
                                    Fclose={hiddenModals}
                                    formulario={
                                      <Select
                                        value={rutaEstatusTemp.length === 1 ? rutaEstatusTemp[0]: { value: 0, label: "Seleccione una Opción", data: null }}
                                        onChange={(er)=>{
                                          let request={ ...e };
                                          request.idRuta= er.value;
                                          getfuntion("put", request, "", "plataformasIncidencias", "Incidencias");
                                        }}
                                        options={rutasEstatus}
                                      />
                                    }
                                  />
                    }
                  }
                },
              ]
            }
            id= "id"
            selected={(e)=>{
              const etiquetaTemp= stor.etiquetas_object.filter(et => et.id === e.idEtiqueta);
              if( etiquetaTemp.length !== 1){
                alert("Precaución la incidencia: \n"+ e.nombre + " \n No esta configurada para envío de notificaciones "+ "\n Contacta a sistemas");
              }
            }}
            csvname= {"Incidencias de la plataforma "+ elementos.nombre}
            resaltarFuncion={(e)=>{
              return incidencias.filter(i => i.incidencia.id === e.id  ).length ? true: false
            }}
            resaltarColor={(e)=>{
              const etiquetaTemp= stor.etiquetas_object.filter(et => et.id === e.idEtiqueta);
              if( etiquetaTemp.length !== 1){
                return "rgba(242, 151, 151, 0.41)";
              }
              return "rgba(58, 223, 149, 0.25)";
            }}
            paginacion={true}
            elementosPorPagina={15}
          />
        </div>
      :null}
    </div>
  )
}

export default Incidencias
